import type { PaginationMetaI } from 'types';
import type { ReportsPaginationI } from '../components/ReportsDataGrid/types';

export const toReportsPagination = (pagination?: PaginationMetaI | null): ReportsPaginationI | null =>
  pagination
    ? {
        page: pagination.page,
        pageSize: pagination.pageSize,
        totalItems: pagination.totalItems,
        totalPages: pagination.totalPages,
      }
    : null;
